$(document).ready(function() {
    $('.js_gallery').each((i,el) => {
        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            breakpoints: {
                568: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30
                }
            },
            navigation: {
                nextEl: '.js_gallery_next',
                prevEl: '.js_gallery_prev'
            },
            pagination: {
                el: '.js_gallery__pagi',
                bulletClass: 'gallery__pagi-item',
                bulletActiveClass: 'active'
            },
            modules: [SwiperModes.Navigation, SwiperModes.Pagination]
        })

        lightGallery(el, {
            selector: 'a',
            licenseKey: 'your_license_key',
            speed: 500,
        })
    })
})